import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/account-setup/accesslevelmaster'
import pathMap from 'src/paths/PathMap_AccountSetup'

class AccessLevelMasterRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ACCESS_LEVEL_MASTER_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ACCESS_LEVEL_MASTER_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ACCESS_LEVEL_MASTER_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ACCESS_LEVEL_MASTER_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default AccessLevelMasterRoute
